!function(e,r){"object"==typeof exports&&"object"==typeof module?module.exports=r():"function"==typeof define&&define.amd?define([],r):"object"==typeof exports?exports.storeblocks=r():e.storeblocks=r()}(self,(()=>(()=>{"use strict";var e={279:(e,r,o)=>{o.d(r,{InlineAlertBase:()=>i,Title:()=>l});const t=require("styled-components");var n=o.n(t);const i=n().div`
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  align-items: top;

  max-width: 560px;
  margin: 0px;

  line-height: 24px;

  & > i {
    flex-shrink: 0;

    color: var(--color-info-accent);
    font-size: 24px;

    margin: 16px 24px 16px 16px;
  }

  ${({$variant:e})=>"error"===e&&t.css`
      outline-color: var(--color-error-accent);

      & > i {
        color: var(--color-error-accent);
      }
    `}

  ${({$variant:e})=>"warning"===e&&t.css`
      outline-color: var(--color-warning-accent);

      & > i {
        color: var(--color-warning-accent);
      }
    `}

  ${({$variant:e})=>"success"===e&&t.css`
      outline-color: var(--color-success-accent);

      & > i {
        color: var(--color-success-accent);
      }
    `}
`,l=n().div`
  /*
  The 12px is due to the line height being 24px instead of 16px as is in the design.
  Must have 24px line height to support multiline.
  16px (original line height) - 24px (multiline line height) = -8px (difference).
  Then those -8px is distributed to top and bottom margins, -4px to each.
  */

  display: flex;
  align-items: center;
  padding: 16px 0;

  color: var(--color-on-background);

  font-size: 16px;
  font-weight: 600;
`}},r={};function o(t){var n=r[t];if(void 0!==n)return n.exports;var i=r[t]={exports:{}};return e[t](i,i.exports,o),i.exports}o.n=e=>{var r=e&&e.__esModule?()=>e.default:()=>e;return o.d(r,{a:r}),r},o.d=(e,r)=>{for(var t in r)o.o(r,t)&&!o.o(e,t)&&Object.defineProperty(e,t,{enumerable:!0,get:r[t]})},o.o=(e,r)=>Object.prototype.hasOwnProperty.call(e,r),o.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var t={};return(()=>{o.r(t),o.d(t,{default:()=>a});const e=require("react");var r=o.n(e);const n=require("@storeblocks/icon");var i=o(279);const l={info:"information-filled",success:"check-circle-filled",warning:"warning-filled",error:"error-filled"},a=function(o){var{title:t,variant:a="info",role:c}=o,s=function(e,r){var o={};for(var t in e)Object.prototype.hasOwnProperty.call(e,t)&&r.indexOf(t)<0&&(o[t]=e[t]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var n=0;for(t=Object.getOwnPropertySymbols(e);n<t.length;n++)r.indexOf(t[n])<0&&Object.prototype.propertyIsEnumerable.call(e,t[n])&&(o[t[n]]=e[t[n]])}return o}(o,["title","variant","role"]);const p=(0,e.useMemo)((()=>null==l?void 0:l[a]),[a]),d=(0,e.useId)();return r().createElement(i.InlineAlertBase,Object.assign({$variant:a,"aria-labelledby":d},s),r().createElement(n.SystemIcon,{name:p,"aria-hidden":"true"}),r().createElement(i.Title,{role:c,id:d},t))}})(),t})()));
//# sourceMappingURL=index.js.map